import { render, staticRenderFns } from "./CoreCompetencies.vue?vue&type=template&id=5c045331&scoped=true"
import script from "./CoreCompetencies.vue?vue&type=script&lang=js"
export * from "./CoreCompetencies.vue?vue&type=script&lang=js"
import style0 from "./CoreCompetencies.vue?vue&type=style&index=0&id=5c045331&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c045331",
  null
  
)

export default component.exports